import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';

import HomeIndex from './Components/HomePage/HomeIndex';
import ContactUsIndex from './Components/ContactUs/ContactUsIndex';
import AboutUsIndex from './Components/AboutUs/AboutUsIndex';
import GalleryIndex from './Components/Gallery/GalleryIndex';
import CoursesIndex from './Components/Courses/CoursesIndex';
import NotFound from './Components/Notfound/Notfound';

// Per-route SEO metadata. Since this is a client-side SPA, the document
// <title> and meta description don't change automatically when the route
// changes — search engines and shared links will otherwise always see
// whatever was in index.html. This keeps each page's <title> accurate for
// users (browser tab, bookmarks, browser history) and for crawlers that
// execute JS. For real per-route social-preview (OG) tags, this still
// needs server-side rendering or prerendering — see note below.
const ROUTE_META = {
  '/': {
    title: 'AnaBel Institute Hassan | Distance Education & Teacher Training Institute',
    description:
      'Govt. approved Distance Education, Teacher Training (NTT), Montessori & skill development courses in Hassan, Karnataka since 2007. 100% placement support.'
  },
  '/courses': {
    title: 'Courses | AnaBel Institute - NTT, Montessori & Distance Education',
    description:
      'Explore Govt. approved NTT, Montessori, Distance Education diploma and skill development courses offered at AnaBel Institute, Hassan.'
  },
  '/about': {
    title: 'About Us | AnaBel Institute Hassan',
    description:
      'Learn about AnaBel Institute\u2019s 19+ years of experience in teacher training and distance education in Hassan, Karnataka, since 2007.'
  },
  '/gallery': {
    title: 'Gallery | AnaBel Institute Hassan',
    description: 'Photos from AnaBel Institute Hassan \u2014 campus, classes, events, and graduating students.'
  },
  '/contact': {
    title: 'Contact Us | AnaBel Institute Hassan',
    description:
      'Get in touch with AnaBel Institute, Hassan for admissions, course details, and enquiries. Call, email, or visit our campus.'
  }
};

function usePageMeta() {
  const location = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[location.pathname];
    if (!meta) return;

    document.title = meta.title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', meta.description);

    // Keep canonical in sync with the current route
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://www.anabel.in${location.pathname}`);
  }, [location.pathname]);
}

function App() {
  usePageMeta();

  return (
    <div style={{ fontFamily: '"Poppins", sans-serif', fontWeight: 400 }}>
      <Routes>
        <Route path="/" element={<HomeIndex />} />
        <Route path="/courses" element={<CoursesIndex />} />
        <Route path="/contact" element={<ContactUsIndex />} />
        <Route path="/about" element={<AboutUsIndex />} />
        <Route path="/gallery" element={<GalleryIndex />} />
        {/* Catch-all so broken/old links get a real 404 page instead of a
            blank screen — both for users and for Google Search Console's
            crawl reports */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;